import { Component, OnInit, Input, booleanAttribute, Output, EventEmitter } from '@angular/core';
import { Truck } from '../../../truck-group.model';

@Component({
  selector: 'app-truck',
  templateUrl: './truck.component.html',
  styleUrls: ['./truck.component.scss']
})
export class TruckComponent implements OnInit {

  @Input() truck: Truck;

  @Input() selected: Truck;

  @Input({ transform: booleanAttribute }) editable: boolean = false;

  @Output() removeTruck = new EventEmitter<Truck>();


  constructor() { }

  ngOnInit() {
  }

  onDelete() {
    this.removeTruck.emit(this.truck);
  }

}
